<template>
  <Teleport to="body">
    <div
      v-if="isVisible"
      class="booking-modal"
    >
      <div>
        <button
          class="booking-modal-close"
          type="button"
          @click="emit('close')"
        >
          {{ translationsStore.t("back") }}
        </button>
      </div>
      <div>
        <DatePicker
          class="booking-datepicker"
          :is-visible="isVisible"
          @select="handleDateSelect"
        />
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { watch, nextTick, ref } from "vue";
import DatePicker from "./molecules/DatePicker.vue";
import { useTranslationsStore } from "../stores/translations";
const translationsStore = useTranslationsStore();
const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["close", "select"]);

const selectedDate = ref(null);

const handleDateSelect = (date) => {
  selectedDate.value = date;
  emit("select", date);
};

watch(
  () => props.isVisible,
  (newVal) => {
    nextTick(() => {
      if (newVal) {
        document.body.style.overflow = "hidden";
        document.querySelector(".modal-container")?.focus();
      } else {
        document.body.style.overflow = "";
      }
    });
  }
);
</script>

<style scoped>
.booking-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(var(--brand-white) / 1);
  padding: 1.25rem;
  z-index: 10;
}
.booking-modal-close {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.75rem;
  padding: 0;
  color: rgb(var(--brand-black) / 1);
  border: none;
}
.booking-modal-close::before {
  width: 1.25rem;
  height: 1.25rem;
  display: inline-block;
  background: url(../assets/icons/left.svg) no-repeat;
  background-size: 100%;
  content: "";
  vertical-align: middle;
  margin-right: 0.75rem;
}
</style>
<style>
.booking-modal .dp__menu {
  border-color: transparent;
}
.booking-modal .dp--arrow-btn-nav {
  display: none;
}
</style>
